// ECAL brand bar color pairs — from the 2026 Brand Guidelines
// Used to assign cover/logo gradients to publishers that arrive without pre-assigned colors
const ECAL_BAR_COLORS = [
    ['#FFDF10', '#FF9E00'],   // 1. warm1  — yellow → orange
    ['#FF9E00', '#FF4D00'],   // 2. warm2  — orange → deep orange
    ['#00D456', '#00D7FF'],   // 3. cool2  — green → light blue
    ['#00D7FF', '#0078FF'],   // 4. cool1  — light blue → mid blue
    ['#0078FF', '#000082'],   // 5. cool3  — mid blue → deep blue
    ['#FFDF10', '#FF4D00'],   // 6. warm full — yellow → deep orange
    ['#00D456', '#0078FF'],   // 7. cool full — green → mid blue
];

export const ECAL_BAR_COLOR_COUNT = ECAL_BAR_COLORS.length;

/**
 * Returns the ECAL bar color pair for a given index, cycling through the set.
 * @param {number} index — zero-based position in the list
 * @returns {[string, string]} — [startColor, endColor]
 */
export function getPublisherColors(index) {
    return ECAL_BAR_COLORS[index % ECAL_BAR_COLOR_COUNT];
}

/**
 * Assigns cyclic ECAL bar colors to a list of publisher objects.
 * Only fills in missing coverColors / logoColors — existing values are preserved.
 * @param {Array} publishers
 * @param {number} [startIndex=0] — offset to start the cycle from
 * @returns {Array} publishers with colors filled in
 */
export function assignPublisherColors(publishers, startIndex = 0) {
    return publishers.map((publisher, index) => {
        const colors = getPublisherColors(startIndex + index);
        return {
            ...publisher,
            coverColors: publisher.coverColors?.length ? publisher.coverColors : colors,
            logoColors:  publisher.logoColors?.length  ? publisher.logoColors  : colors,
        };
    });
}

export default ECAL_BAR_COLORS;
